import cx from 'classnames';
const HomeArticles = ({ containerClass, articles }) => {
    return (<div className={cx(containerClass)}>
      <h1 className="home-article-title-left">Welcome to Mount Rainier CodeConnect</h1>
      {articles.map(({ article }) => (<article key={article.id} className="home-article" id={article.id}>
          <div dangerouslySetInnerHTML={{ __html: article.body }} className="home-article-info"/>
        </article>))}
    </div>);
};
export default HomeArticles;
